<template>
  <div class="top_navabr">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <button class="navbar-toggler" id="toggleButton" onclick="window.global.toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="top-nav-content">
          <a
            href="javascript:void(0)"
            class="notification"
            :class="{ zero: notificationCount <= 0 }"
            :data-after="notificationCount"
            @click="showNotifications"
            ><i class="fa-solid fa-bell icons"></i
          ></a>
        </div>
        <div id="navbarNav" style="display: none">
          <ul class="navbar-nav nav-2">
            <li>
              <a
                class="nav-link"
                :class="{ active: this.section === 'DashboardPage' }"
                href="/"
                ><i class="fa-solid fa-house icons"></i>Dashboard</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/perfil"
                :class="{ active: this.section === 'ProfilePage' }"
                ><i
                  class="fa-solid fa-user icons"
                  style="padding-left: 4px; margin-right: 11px"
                ></i
                >Meu perfil</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/plano"
                :class="{ active: this.section === 'PlanPage' }"
                ><i
                  class="fa-regular fa-credit-card"
                  style="padding-left: 0px; margin-right: 12px"
                ></i
                >Assinaturas</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/cursos"
                :class="{
                  active:
                    this.section === 'CourseListPage' ||
                    this.section.startsWith('CoursePage') ||
                    this.section === 'CourseNotFoundPage' ||
                    this.section === 'ClassPage',
                }"
                ><i
                  class="fa-solid fa-graduation-cap icons"
                  style="padding-left: 3px; margin-right: 5px"
                ></i>
                Cursos
                <!-- <span class="badge bg-primary ms-2">NOVO</span> -->
              </a>
            </li>
            <li v-if="this.userPlan === 'Starter' || this.userPlan === 'VirtapClub'">
              <a
                class="nav-link"
                href="/aulas"
                :class="{
                  active:
                    this.section === 'VideoListPage' ||
                    this.section === 'VideoPage' ||
                    this.section === 'VideoNotFoundPage',
                }"
                ><i
                  class="fa-brands fa-youtube icons"
                  style="padding-left: 2px; margin-right: 10px"
                ></i
                >Aulas extras
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                href="/mentorias"
                :class="{
                  active:
                    this.section === 'CourseMentorshipListPage' ||
                    this.section === 'MentorshipPage' ||
                    this.section === 'MentorshipNotFoundPage',
                }"
                ><i
                  class="fa fa-comments icons"
                  style="padding-left: 2px; margin-right: 10px"
                ></i
                >Mentorias
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                href="/comunidade"
                :class="{
                  active: this.section === 'CommunityPage',
                }"
                ><i class="fa-solid fa-users icons"></i>Comunidade
              </a>
            </li>
            <!-- <li>
              <a class="nav-link" href="/ferramentas" :class="{
                active:
                  this.section === 'ToolListPage'
              }"><i class="fa-solid fa-gears icons"></i>Ferramentas
              </a>
            </li> -->
            <li>
              <a
                class="nav-link"
                href="/projetos"
                :class="{
                  active:
                    this.section === 'ProjectListPage' ||
                    this.section === 'ProjectPage' ||
                    this.section === 'ClientPage',
                }"
                ><i
                  class="fa-solid fa-bag-shopping icons"
                  style="padding-left: 5px; margin-right: 11px"
                ></i
                >Oportunidades</a
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="/propostas"
                :class="{
                  active:
                    this.section === 'ProposalListPage' ||
                    this.section === 'ProposalPage',
                }"
                ><i
                  class="fa-solid fa-file-lines icons"
                  style="padding-left: 6px; margin-right: 11px"
                ></i
                >Minhas propostas
              </a>
            </li>
            <li>
              <a
                class="nav-link"
                href="/contato"
                :class="{
                  active: this.section === 'ContactPage',
                }"
                ><i
                  class="fa-solid fa-headset icons"
                  style="padding-left: 5px; margin-right: 11px"
                ></i
                >Suporte
              </a>
            </li>
            <li>
              <a class="nav-link" :href="logoutURL"
                ><i
                  class="fa-solid fa-arrow-right-from-bracket"
                  style="padding-left: 2px; margin-right: 10px"
                ></i>
                Sair
              </a>
            </li>
            <!-- <li>
              <a
                class="nav-link"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#support"
                ><i class="fa-solid fa-headset icons"></i>Support</a
              >
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Config from "../../../resources/config.js";
import AssistantManager from "../../js/services/assistant.js";

export default {
  data() {
    return {};
  },

  computed: {
    section() {
      return this.$store.state.activeSection;
    },
    activeUser() {
      return this.$store.state.activeUser;
    },
    userPlan() {
      let user = this.$store.state.activeUser;
      if (user && user.plan) {
        return user.plan;
      }
      return null;
    },
    notificationCount() {
      return this.activeUser.last_notif_id - this.activeUser.seen_notif_id;
    },
    logoutURL() {
      return `${Config.apiHost}/logout`;
    },
  },

  methods: {
    async showNotifications() {
      let ctx = this;
      let $modal = $("#notificationsModal");
      $modal.find(".notification").html('<div class="loading">Carregando...</div>');
      $modal.modal("show");

      $modal.off().on("shown.bs.modal", async function () {
        try {
          let notifications = await AssistantManager.getNotifications(
            ctx.activeUser.last_notif_id
          );

          if (notifications.length > 0) {
            $modal.find(".notification").html("");
            notifications.forEach((notification) => {
              let n = $(
                '<div class="item">' +
                  '   <div class="sourch">' +
                  '       <img src="/assets/img/notification_mail.png" alt="" />' +
                  '       <div class="text">' +
                  "           <p></p>" +
                  '           <span class="date"></span>' +
                  "       </div>" +
                  "   </div>" +
                  "</div>"
              );

              if (notification.notification_type === "signup-approved") {
                n.find(".text > p").html("Bem-vindo à Virtap!");
              } else if (notification.notification_type === "profile-approved") {
                n.find(".text > p").html(
                  "Bem vindo à Virtap! Seu cadastro foi aprovado!"
                );
              } else if (notification.notification_type === "proposal-approved") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Sua proposta para o projeto <strong data-project-title></strong> foi aprovada e agora está visível para <strong data-client-name></strong>. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-la</a>.'
                );
                n.find("a").attr("href", "/projeto/" + data.project_id);
                n.find("[data-project-title]").text(data.project_title);
                n.find("[data-client-name]").text(data.client_name);
              } else if (notification.notification_type === "proposal-accepted") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  '<strong data-client-name></strong> quer conversar sobre sua proposta para o projeto <strong data-project-title></strong>. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-la</a>.'
                );
                n.find("a").attr("href", "/projeto/" + data.project_id);
                n.find("[data-project-title]").text(data.project_title);
                n.find("[data-client-name]").text(data.client_name);
              } else if (notification.notification_type === "invited-to-project") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  '<strong data-client-name></strong> te convidou para o projeto <strong data-project-title></strong>. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-lo</a>.'
                );
                n.find("a").attr("href", "/projeto/" + data.project_id);
                n.find("[data-project-title]").text(data.project_title);
                n.find("[data-client-name]").text(data.client_name);
              } else if (notification.notification_type === "project-closed") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'O projeto <strong data-project-title></strong> para o qual você enviou uma proposta foi encerrado. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-lo</a>.'
                );
                n.find("a").attr("href", "/projeto/" + data.project_id);
                n.find("[data-project-title]").text(data.project_title);
              } else if (notification.notification_type === "hired-to-project") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Parabéns pela contratação no projeto <strong data-project-title></strong>! <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-lo</a>.'
                );
                n.find("a").attr("href", "/projeto/" + data.project_id);
                n.find("[data-project-title]").text(data.project_title);
              } else if (notification.notification_type === "feedback-given") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  '<strong data-client-name></strong> te deixou uma avaliação na plataforma! <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para ver suas avaliações</a>.'
                );
                n.find("a").attr("href", "/perfil");
                n.find("[data-client-name]").text(data.client_name);
              }
              // test here and below
              else if (notification.notification_type === "pending-subscription") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Sua assinatura do plano <strong data-subscription-plan></strong> está pendente. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para ativá-la</a>.'
                );
                n.find("a").attr("href", "/plano");
                n.find("[data-subscription-plan]").text(
                  data.subscription_plan === "VirtapClub"
                    ? "Virtap Club"
                    : data.subscription_plan
                );
              } else if (notification.notification_type === "expired-subscription") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Sua assinatura do plano <strong data-subscription-plan></strong> expirou. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para reativá-la</a>.'
                );
                n.find("a").attr("href", "/plano");
                n.find("[data-subscription-plan]").text(
                  data.subscription_plan === "VirtapClub"
                    ? "Virtap Club"
                    : data.subscription_plan
                );
              } else if (notification.notification_type === "pending-course") {
                let data = JSON.parse(notification.notification_data);
                if (data.course_id === "form-ap") {
                  n.find(".text > p").html(
                    'Seu acesso à <strong data-course>Formação AExpert</strong> está pendente. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para ativá-lo</a>.'
                  );
                  n.find("a").attr("href", "/curso/form-ap");
                }
              } else if (notification.notification_type === "expired-course") {
                let data = JSON.parse(notification.notification_data);
                if (data.course_id === "form-ap") {
                  n.find(".text > p").html(
                    'Seu acesso à <strong data-course>Formação AExpert</strong> expirou. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para reativá-lo</a>.'
                  );
                  n.find("a").attr("href", "/curso/form-ap");
                }
              } else if (notification.notification_type === "video-comment-replied") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Seu comentário na aula <strong data-title></strong> foi respondido. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para conferir</a>.'
                );
                n.find("[data-title]").text(data.video_title);
                n.find("a").attr("href", "/aula/" + data.video_id);
              } else if (notification.notification_type === "class-comment-replied") {
                let data = JSON.parse(notification.notification_data);
                n.find(".text > p").html(
                  'Seu comentário na aula <strong data-title></strong> foi respondido. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para conferir</a>.'
                );
                n.find("[data-title]").text(data.class_title);
                n.find("a").attr(
                  "href",
                  "/curso/" + data.course_id + "/" + data.class_id
                );
              }
              n.find(".date").text(
                ctx.formatElapsedTime(notification.registration_timestamp)
              );

              if (notification.user_notification_id > ctx.activeUser.seen_notif_id) {
                n.addClass("active");
              }

              $modal.find(".notification").append(n);
            });
          } else {
            $modal
              .find(".notification")
              .html('<div class="loading">Nenhuma notificação disponível.</div>');
          }

          try {
            await AssistantManager.setLastSeenNotifications(ctx.activeUser.last_notif_id);
          } catch (err) {
            console.log(err);
          }
          ctx.activeUser.seen_notif_id = ctx.activeUser.last_notif_id;
        } catch (err) {
          console.log(err);
          $modal
            .find(".notification")
            .html(
              '<div class="loading text-danger">Erro ao carregar as notificações.<br/> Por favor, tente novamente. Se o problema persistir, atualize a página.</div>'
            );
        }
      });
    },
  },
};
</script>
